import { Container } from "../../components/FormPreviewer/Container";
import { Form } from "../../components/FormPreviewer/Form";
import { Previewer } from "../../components/FormPreviewer/Previewer";
import { Canvas } from "./Canvas";

export const UpsellTab = () => (
  <Container>
    <Form />
    <Previewer>
      <Canvas.EmptyState />
    </Previewer>
  </Container>
);
